module.exports = __webpack_public_path__ + "img/guest.7bd4013e.png";